import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import core from "./common/core";
import app from "./common/app";
import config from "./common/config";
import "promise-polyfill/src/polyfill";
import reportWebVitals from "./reportWebVitals";

config.VersionCookie = window.VersionCookie || 0;
config.playerImageVersionN = window.playerImageVersionN || 1;
//Webview

config.captainGdDates = {
  captain: window.captainLeagueGD || 37,
  vCaptain: window.vCaptainLeagueGD || 45,
  knockOut: window.knockOutLeagueGD || 71,
};

config.homeSwiperLeague = window.homeSwiperLeague;

const isWebView = app.isWebView();
if (isWebView) {
  const csrf = core.getCookie(config.COOKIE_CSRF);
  if (!csrf) {
    const now = Date.now();
    const expire = 365; //app.add_years(new Date(), 10);
    core.setCookie(config.COOKIE_CSRF, now, expire);
  }

  config.morePage = [
    {
      title: "help",
      links: [
        {
          Linktitle: "menuRules",
          key: 4,
          navLink: `${config.enumStaticUrls.rules}`,
          isRelative: true,
        },
        {
          Linktitle: "fantasy_point_system",
          key: 1,
          navLink: config.moreLink.fantasyPointSystem,
        },
        {
          Linktitle: "how_to_play",
          key: 2,
          navLink: config.moreLink.helpCenter,
        },
        // { Linktitle: "contactUs", key: 3, navUrl: config.moreLink.contactUs },
      ],
      key: 3,
    },
  ];
}
//Webview

let cookie = app.getLoginCookie();
core.addClassToElement(
  document,
  "body",
  `si-${config.CURRENT_LANGUAGE.toLocaleLowerCase()}`,
  false
);
config.IS_MOBILE = core.isMobile();
config.IS_TABLET = core.isTablet();
if (cookie) {
  let team = core.getCookie(config.enumBusters.team);

  if (!team || isNaN(team)) {
    core.CompCacheBusterCookie(config.enumBusters.team);
  }

  let publicContest = core.getCookie(config.enumBusters.publicContest);
  if (!publicContest || isNaN(publicContest)) {
    core.CompCacheBusterCookie(config.enumBusters.publicContest);
  }

  let privateContest = core.getCookie(config.enumBusters.privateContest);
  if (!privateContest || isNaN(privateContest)) {
    core.CompCacheBusterCookie(config.enumBusters.privateContest);
  }
  let badge = core.getCookie(config.enumBusters.badge);
  if (!badge || isNaN(badge)) {
    core.CompCacheBusterCookie(config.enumBusters.badge);
  }

  let profile = core.getCookie(config.enumBusters.profile);
  if (!profile || isNaN(profile)) {
    core.CompCacheBusterCookie(config.enumBusters.profile);
  }
}
app.renderDom = () => {
  return ReactDOM.render(
    <App key={Math.random()} />,
    document.getElementById("container")
  );
};
app.renderDom();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
